import { getUpsellSequence } from '@/modules/upsell/application/get-upsell-sequence.use-case';
import { maxTreeDepth } from '@/modules/upsell/application/upsell-sequence';
import UpsellService from '@/services/upsell.service';

import {
  SET_UPSELL_OVERLAY,
  SET_UPSELL_PRICING_MODEL,
  SET_UPSELL_PRODUCT_TYPE,
  SET_UPSELL_SEQUENCE_SNAPSHOT,
  SET_UPSELL_TOUR_ID,
} from '../mutation-types';

export async function initializeUpsellSequence({ commit }, { query, countryCode, getBrand }) {
  const upsellData = UpsellService.initializeUpsellData(query, countryCode, getBrand);

  commit(SET_UPSELL_PRODUCT_TYPE, upsellData.upsellProductType);
  commit(SET_UPSELL_PRICING_MODEL, upsellData.upsellPricingModel);
  commit(SET_UPSELL_TOUR_ID, query['tour-id'] || upsellData.upsellProductType);

  const resolved = getUpsellSequence({
    productType: upsellData.upsellProductType,
    pricingModel: upsellData.upsellPricingModel,
    region: upsellData.region,
    brand: upsellData.brand,
  });

  commit(SET_UPSELL_SEQUENCE_SNAPSHOT, {
    sequence: resolved?.sequence ?? null,
    sequenceTree: resolved?.sequenceTree ?? null,
    currentSequenceTree: resolved?.sequenceTree ?? null,
    cursor: null,
    progressIndex: 0,
    progressTotal: maxTreeDepth(resolved?.sequenceTree ?? null),
  });

  return upsellData;
}

export function setSequenceSnapshot({ commit }, payload) {
  commit(SET_UPSELL_SEQUENCE_SNAPSHOT, payload);
}

export function setUpsellOverlay({ commit }, payload) {
  commit(SET_UPSELL_OVERLAY, payload);
}
